import * as tslib_1 from "tslib";
import React, { useContext } from 'react';
var BiContext = React.createContext({});
BiContext.displayName = 'BiContext';
var BiLoggerContextConsumer = BiContext.Consumer;
/**
 * Merge context for nested providers
 */
var BiLoggerContextProvider = function (_a) {
    var children = _a.children, value = _a.value;
    var parentContext = useContext(BiContext);
    var merged = tslib_1.__assign({}, parentContext, value);
    return React.createElement(BiContext.Provider, { value: merged }, children);
};
BiLoggerContextProvider.displayName = 'BiLoggerContextProvider';
export { BiLoggerContextProvider, BiLoggerContextConsumer, BiContext };
//# sourceMappingURL=BiLogger.context.js.map